import { createSelector } from 'reselect';
import { map, has } from 'lodash';

export const promotionalUpdateName = 'Promotional Update';


function getPurposeOptions(purposesArray) {
  const purposeGroups = purposesArray.reduce((purposeGroups, purpose) => {
    if (purpose.name === promotionalUpdateName) {
      purposeGroups.PROMOTIONAL.push(purpose);
    } else {
      purposeGroups['NON-PROMOTIONAL'].push(purpose);
    }

    return purposeGroups;
  }, { PROMOTIONAL: [], 'NON-PROMOTIONAL': [] });

  return map(purposeGroups, (suggestions, title) => ({ suggestions, title }));
}


export const selectCampaignPurposes = state => {
  const hasPurposes = has(state, 'campaignPurposes.purposes');

  return hasPurposes ? state.campaignPurposes.purposes : [];
};

export const purposeOptionsSelector = createSelector(
  selectCampaignPurposes,
  getPurposeOptions,
);
